import { useRef } from 'react';

import {
    cleanUpProgramaticFocusAttributes,
    moveFocusProgramatically,
} from '../utils/programaticFocus';

export const useTemporaryImperativeFocus = <T extends HTMLElement>() => {
    const ref = useRef<T>(null);

    const moveFocus = () => {
        if (ref.current) {
            moveFocusProgramatically(ref.current);
        }
    };

    const onBlurCapture = (event: React.FocusEvent<T>) => {
        if (event.target === ref.current) {
            cleanUpProgramaticFocusAttributes(event.target as HTMLElement);
        }
    };

    return {
        ref,
        moveFocus,
        onBlurCapture,
    };
};
